import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import navigateWidgetSvg from '../../../../../assets/images/navigate-widget.svg';
import { getQRCode } from '../navigate-on-phone';
import { getQrCodeRichMapId, getPOIS, getResetWidgets, getShowQRFrame, } from '../../../../../store/uislice';
import { getContext, getLocation, getSelectedLocation, } from '../../../redux/spaces-slice';
const Container = styled.div `
  position: relative;
  width: clamp(9.6rem, 10.1vw, 10.7rem);
  margin-left: clamp(0.3rem, 0.35vw, 0.45rem);
  flex: 0 0 auto;
  z-index: 2;
`;
const WidgetButton = styled.button `
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  width: 100%;
  cursor: pointer;
  position: relative;
  display: block;
`;
const WidgetImage = styled.img `
  display: block;
  width: 100%;
  height: auto;
`;
const WidgetCopyMask = styled.div `
  position: absolute;
  left: 9%;
  right: 9%;
  /* Start the dark panel just below the blue status dot (~8% from the top of the
     widget). Any higher and this same-colored card overlaps and clips the dot. */
  top: 9%;
  bottom: 59%;
  border-radius: clamp(0.8rem, 0.92vw, 1rem);
  background: #232a31;
  pointer-events: none;
`;
const WidgetCopy = styled.div `
  position: absolute;
  left: ${({ $expanded }) => ($expanded ? '11%' : '9%')};
  right: ${({ $expanded }) => ($expanded ? '11%' : '9%')};
  top: ${({ $expanded }) => ($expanded ? '7.8%' : '8.2%')};
  bottom: ${({ $expanded }) => ($expanded ? '60%' : '60.5%')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ $expanded }) => $expanded
    ? 'clamp(0.95rem, 1.1vw, 1.2rem)'
    : 'clamp(0.44rem, 0.5vw, 0.56rem)'};
  text-align: center;
  color: #ffffff;
  font-family: 'Sora', sans-serif;
  pointer-events: none;
`;
const WidgetTitle = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ $expanded }) => $expanded
    ? 'clamp(0.08rem, 0.1vw, 0.12rem)'
    : 'clamp(0.04rem, 0.05vw, 0.08rem)'};
  font-size: ${({ $expanded }) => $expanded
    ? 'clamp(1.25rem, 1.44vw, 1.53rem)'
    : 'clamp(0.95rem, 1.04vw, 1.08rem)'};
  max-width: 100%;
  min-width: 0;
  font-weight: 700;
  line-height: 1.06;
  letter-spacing: -0.03em;
`;
const WidgetBody = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ $expanded }) => $expanded
    ? 'clamp(0.08rem, 0.1vw, 0.12rem)'
    : 'clamp(0.03rem, 0.04vw, 0.06rem)'};
  font-size: ${({ $expanded }) => $expanded
    ? 'clamp(0.82rem, 0.92vw, 0.98rem)'
    : 'clamp(0.5rem, 0.55vw, 0.58rem)'};
  font-weight: 400;
  line-height: 1.18;
  letter-spacing: -0.02em;
  color: rgba(255, 255, 255, 0.9);
`;
const WidgetCopyLine = styled.span `
  display: block;
  overflow-wrap: anywhere;
`;
const QRSlot = styled.div `
  position: absolute;
  left: 21.1%;
  top: 42%;
  width: 56.8%;
  aspect-ratio: 1;
  padding: ${({ $expanded }) => $expanded
    ? 'clamp(0.2rem, 0.24vw, 0.26rem)'
    : 'clamp(0.13rem, 0.16vw, 0.18rem)'};
  border-radius: clamp(0.72rem, 0.78vw, 0.86rem);
  background: #fbfbfb;
  box-shadow:
    0 0 0 1px rgba(17, 20, 24, 0.82),
    0 8px 18px rgba(0, 0, 0, 0.28);
`;
const QRCodeInset = styled.div `
  width: 94%;
  height: 94%;
  margin: 3%;
`;
const ExpandButton = styled.button `
  appearance: none;
  box-sizing: border-box;
  border: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 50%;
  bottom: ${({ $expanded }) => ($expanded ? '8.2%' : '7.8%')};
  transform: translateX(-50%);
  width: ${({ $expanded }) => $expanded ? 'max-content' : 'clamp(6.3rem, 6.7vw, 7rem)'};
  min-width: ${({ $expanded }) => $expanded ? 'clamp(6rem, 6.8vw, 6.7rem)' : '0'};
  height: ${({ $expanded }) => $expanded ? 'auto' : 'clamp(2.2rem, 2.3vw, 2.35rem)'};
  padding: ${({ $expanded }) => $expanded
    ? 'clamp(0.72rem, 0.84vw, 0.9rem) clamp(0.84rem, 0.98vw, 1rem)'
    : 'clamp(0.2rem, 0.24vw, 0.25rem) clamp(0.45rem, 0.52vw, 0.55rem)'};
  border-radius: 0.4rem;
  background: linear-gradient(180deg, #3690ff 0%, #1c73e2 100%);
  box-shadow:
    inset 0 1px 0 rgba(194, 226, 255, 0.38),
    0 10px 18px rgba(0, 0, 0, 0.25);
  color: #ffffff;
  font-family: 'Sora', sans-serif;
  font-size: ${({ $expanded }) => $expanded
    ? 'clamp(0.84rem, 0.96vw, 0.98rem)'
    : 'clamp(0.66rem, 0.72vw, 0.76rem)'};
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.01em;
  text-align: center;
  max-width: ${({ $expanded }) => $expanded
    ? 'calc(100% - clamp(0.7rem, 0.9vw, 0.95rem))'
    : 'calc(100% - clamp(0.2rem, 0.24vw, 0.3rem))'};
  white-space: normal;
  overflow-wrap: break-word;
  text-wrap: balance;
  cursor: pointer;
`;
const Overlay = styled.button `
  appearance: none;
  border: 0;
  padding: 0;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.68);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
`;
const ExpandedWidget = styled.div `
  position: relative;
  width: min(19rem, 28vw);
`;
const getPoiID = (POISNameMap, name) => {
    for (const POI in POISNameMap) {
        if (POISNameMap[POI].name === name) {
            return POISNameMap[POI].poiId;
        }
    }
};
const QRFrame = () => {
    const [qrCode, setQrCode] = useState('');
    const [tapToExpand, setTapToExpand] = useState(false);
    const qrCodeIntervalRef = useRef(null);
    const contextInfo = useSelector(getContext);
    const showQRFrame = useSelector(getShowQRFrame);
    const resetWidgets = useSelector(getResetWidgets);
    const floorLocationId = useSelector(getSelectedLocation);
    const locationData = useSelector(getLocation);
    const qrCodeRichMapId = useSelector(getQrCodeRichMapId);
    const POISNameMap = useSelector(getPOIS).POISNameMap;
    const { t } = useTranslation();
    const tenantId = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.tenantId;
    const locationId = locationData === null || locationData === void 0 ? void 0 : locationData.id;
    const widgetAriaLabel = `${t('floor.navigate-on-phone.label-1')} ${t('floor.navigate-on-phone.label-2')}`;
    const widgetCopy = (expanded = false) => (_jsxs(_Fragment, { children: [_jsx(WidgetCopyMask, {}), _jsxs(WidgetCopy, Object.assign({ "$expanded": expanded }, { children: [_jsxs(WidgetTitle, Object.assign({ "$expanded": expanded }, { children: [_jsx(WidgetCopyLine, { children: t('floor.navigate-on-phone.label-1') }), _jsx(WidgetCopyLine, { children: t('floor.navigate-on-phone.label-2') })] })), _jsxs(WidgetBody, Object.assign({ "$expanded": expanded }, { children: [_jsx(WidgetCopyLine, { children: t('floor.navigate-on-phone.label-3') }), _jsx(WidgetCopyLine, { children: t('floor.navigate-on-phone.label-4') })] }))] }))] }));
    useEffect(() => {
        if (!tenantId || (!floorLocationId && !locationId)) {
            return undefined;
        }
        const refreshQrCode = () => {
            if (qrCodeRichMapId) {
                getQRCode({
                    tenantId,
                    locationId,
                    poiId: getPoiID(POISNameMap, qrCodeRichMapId.split('~')[1]),
                    setter: setQrCode,
                });
                return;
            }
            getQRCode({
                tenantId,
                locationId: floorLocationId,
                poiId: undefined,
                setter: setQrCode,
            });
        };
        refreshQrCode();
        if (qrCodeIntervalRef.current) {
            clearInterval(qrCodeIntervalRef.current);
        }
        qrCodeIntervalRef.current = window.setInterval(refreshQrCode, 86400000);
        return () => {
            if (qrCodeIntervalRef.current) {
                clearInterval(qrCodeIntervalRef.current);
            }
        };
    }, [POISNameMap, floorLocationId, locationId, qrCodeRichMapId, tenantId]);
    useEffect(() => {
        if (resetWidgets > 0) {
            setTapToExpand(false);
        }
    }, [resetWidgets]);
    if (!showQRFrame) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [tapToExpand && (_jsx(Overlay, Object.assign({ onClick: () => setTapToExpand(false) }, { children: _jsxs(ExpandedWidget, Object.assign({ onClick: (event) => event.stopPropagation() }, { children: [_jsx(WidgetImage, { src: navigateWidgetSvg, alt: widgetAriaLabel }), widgetCopy(true), _jsx(QRSlot, Object.assign({ "$expanded": true }, { children: _jsx(QRCodeInset, { children: _jsx(QRCodeSVG, { value: qrCode, size: 1024, bgColor: "#ffffff", fgColor: "#111417", level: "L", includeMargin: false, style: { display: 'block', width: '100%', height: '100%' } }) }) })), _jsx(ExpandButton, Object.assign({ "$expanded": true, onClick: () => setTapToExpand(false) }, { children: t('floor.navigate-on-phone.close') }))] })) }))), _jsx(Container, { children: _jsxs(WidgetButton, Object.assign({ onClick: () => setTapToExpand(true) }, { children: [_jsx(WidgetImage, { src: navigateWidgetSvg, alt: widgetAriaLabel }), widgetCopy(), _jsx(QRSlot, { children: _jsx(QRCodeInset, { children: _jsx(QRCodeSVG, { value: qrCode, size: 1024, bgColor: "#ffffff", fgColor: "#111417", level: "L", includeMargin: false, style: { display: 'block', width: '100%', height: '100%' } }) }) }), _jsx(ExpandButton, Object.assign({ type: "button" }, { children: t('floor.navigate-on-phone.tap-to-expand') }))] })) })] }));
};
export default QRFrame;
